import { cn } from "../lib";
import { BodyText } from "./typography";

export interface TabItem {
  label: string;
  value: string;
  count?: number | string;
  badge?: React.ReactNode;
}

interface TabsProps {
  items: TabItem[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

const Tabs = ({ items, value, onChange, className }: TabsProps) => {
  return (
    <div className={cn("border-b border-[#E4E7F4]", className)}>
      <div className="flex items-center gap-6 overflow-x-auto">
        {items.map((item) => {
          const isActive = item.value === value;
          return (
            <button
              key={item.value}
              type="button"
              onClick={() => onChange(item.value)}
              className="shrink-0"
            >
              <BodyText
                className={cn(
                  "border-b-2 px-1 pb-2 text-[16px] font-[400] transition-colors whitespace-nowrap inline-flex items-center",
                  isActive
                    ? "border-primary-20 text-gray-30"
                    : "border-transparent text-gray-20 hover:text-gray-30",
                )}
              >
                <span>{item.label}</span>
                {item.badge ? (
                  item.badge
                ) : item.count !== undefined ? (
                  <span className="ml-2 text-[#7A7FAA]">{item.count}</span>
                ) : null}
              </BodyText>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export { Tabs };
